// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"waybills__loadingContainer___2PlBL","errorContainer":"waybills__errorContainer___12U5z","page":"waybills__page___3FQS0"};